import React from 'react';
import dompurify from 'dompurify';

export const getBallotOptionLabel = (group, option) => {
    return (
        <div className="inline-block">
            <span className="font-medium block">{option.ballotOptionName}</span>
            {option.ballotOptionSubName && <span className="block">{option.ballotOptionSubName}</span>}

            {group.isShowBiography && group.biographyType === "OnBallot" &&
                <span className="block break-all" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(option.ballotOptionDescription) }} />}

            {group.isShowBiography && group.biographyType === "ExternalLink" &&
                <a href={option.externalLink} className="block" target="_blank" rel="noreferrer">Click to view biography</a>}

            {group.isShowBiography && group.biographyType === "External" &&
                <a href={getExternalBioQuery(option)} className="block" target="_blank" rel="noreferrer">Click to view biography</a>}
        </div>
    )
}

export const getBallotOptionImage = (group, option) => {
    return (
        <React.Fragment>
            {
                group.isShowBiography && group.biographyType === "OnBallot" && option.ballotOptionPhotoId &&
                <img className="max-w-[200px] mr-4 float-left object-contain" src={`/vote/bioImg${getExternalBioQuery(option)}`} alt={option.ballotOptionName} />
            }
        </React.Fragment>
    )
}

export const getExternalBioQuery = (option) => {
    return window.location.search + `&bio=${option.ballotOptionId}`
}